// Author YuJiaBei
// Date 2020-10-10 14:00:25

class SithMesMstPosition {
constructor({
        id = null,
        name = '',
        parentId = '',
        parentName = '',
        level = '',
        nodeCode = '',
        seq = '',
        externalId = '',
        andonUpgradeTime = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.parentId = parentId;
    this.parentName = parentName;
    this.level = level;
    this.nodeCode = nodeCode;
    this.seq = seq;
    this.externalId = externalId;
    this.andonUpgradeTime = andonUpgradeTime;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstPosition();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstPosition.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentId',
        label: 'label.sith.mst.sithMesMstPosition.grid.parentId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.sith.mst.sithMesMstPosition.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.sith.mst.sithMesMstPosition.grid.nodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.sith.mst.sithMesMstPosition.grid.seq',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'externalId',
        label: 'label.sith.mst.sithMesMstPosition.grid.externalId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'andonUpgradeTime',
        label: 'label.sith.mst.sithMesMstPosition.grid.andonUpgradeTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstPosition.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    nameFilter : "",
    parentIdFilter : "",
    parentNameFilter : "",
    levelFilter : "",
    nodeCodeFilter : "",
    seqFilter : "",
    externalIdFilter : "",
    andonUpgradeTimeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.mst.sithMesMstPosition.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentNameFilter',
        label: 'label.sith.mst.sithMesMstPosition.filter.parentName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstPosition'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstPosition.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentName',
        label: 'label.sith.mst.sithMesMstPosition.entity.parentName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstPosition'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                }
        },
        {
        key: 'andonUpgradeTime',
        label: 'label.sith.mst.sithMesMstPosition.entity.andonUpgradeTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstPosition.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstPosition, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
